import { getEditableField } from '../store/selectors';
var isUploadedImage = function (image) {
    return image.startsWith('http');
};
var base64ToFile = function (base64, filename) {
    var parts = base64.split(',');
    var mimeMatch = parts[0].match(/data:(.*);base64/);
    var mimeType = (mimeMatch === null || mimeMatch === void 0 ? void 0 : mimeMatch[1]) || 'application/octet-stream';
    var ext = mimeType.split('/')[1] || 'bin';
    var name = "".concat(filename, "-").concat(Date.now(), ".").concat(ext);
    var base64Data = parts[1];
    var byteCharacters = atob(base64Data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], name, { type: mimeType });
};
export var buildApiPayloadImagesFromStore = function (params) {
    var state = params.store.getState();
    var coverImage = getEditableField(state, 'emailCoverImage').value;
    var logoImage = getEditableField(state, 'emailLogoImage').value;
    var shouldUploadCoverImage = !!coverImage && !isUploadedImage(coverImage);
    var shouldUploadLogoImage = !!logoImage && !isUploadedImage(logoImage);
    var shouldRemoveLogo = logoImage === '';
    if (!shouldUploadCoverImage && !shouldUploadLogoImage && !shouldRemoveLogo) {
        return null;
    }
    var data = {};
    if (shouldUploadCoverImage) {
        data.background = base64ToFile(coverImage, 'background');
    }
    if (shouldUploadLogoImage) {
        data.logo = base64ToFile(logoImage, 'logo');
    }
    else if (shouldRemoveLogo) {
        data.logo = '';
    }
    return data;
};
export var buildStoreImagesFromApiCampaign = function (_a) {
    var _b, _c;
    var campaign = _a.campaign;
    return {
        emailCoverImage: { value: ((_b = campaign.background) === null || _b === void 0 ? void 0 : _b.url) || null },
        emailLogoImage: {
            value: ((_c = campaign.logo) === null || _c === void 0 ? void 0 : _c.url) || null,
        },
    };
};
